import React, { useState } from 'react';
import styles from './AdminHeader.module.css';
import { useAuth } from '../../context/AuthContext';

const AdminHeader = ({ onMenuClick }) => {
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const { logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    window.location.href = '/admin';
  };

  return (
    <header className={styles.adminHeader}>

      <div className={styles.leftSection}>
        <button className={styles.menuButton} onClick={onMenuClick}>
          <span className={styles.menuIcon}>☰</span>
        </button>
        <h1 className={styles.logo}>Panel de Administración</h1>
      </div>

      <div className={styles.rightSection}>
        <div className={styles.userInfo}>
          <div
            className={styles.avatar}
            onClick={() => setIsProfileOpen(!isProfileOpen)}
          >
            AD
          </div>
          {isProfileOpen && (
            <div className={styles.profileDropdown}>
              <div className={styles.profileItem} onClick={handleLogout}>
                <span>🚪</span>
                Cerrar Sesión
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
